export const environment = {
  production: true,
  maui: false
};
